import ChatInterfacePanel from './ChatInterfacePanel';
export default ChatInterfacePanel;
